import { render } from "./ContactSkipper.vue?vue&type=template&id=2e6aabca&scoped=true"
import script from "./ContactSkipper.vue?vue&type=script&lang=js"
export * from "./ContactSkipper.vue?vue&type=script&lang=js"

import "./ContactSkipper.vue?vue&type=style&index=0&id=2e6aabca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2e6aabca"

export default script